import axios from "axios";
const baseURL = process.env.VUE_APP_V3_API_BASE_URL;

export default axios.create({
    baseURL,
    timeout: 300000,
}); 